import { FC } from "react";
import "./TransparentPreloader.scss";
import { useAppSelector as useSelector } from "../../../store";
import Loader from "../../Loader";

const TransparentPreloader: FC = () => {
  const isShow = useSelector((state) => state.app.isShow);

  return isShow ? (
    <div className={`transparent-preloader`}>
      <Loader />
      {/* <div className='transparent-preloader__spinner' /> */}
    </div>
  ) : (
    <></>
  );
};

export default TransparentPreloader;
